/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { clone, difference, differenceBy, uniqueId } from 'lodash';

// Components
import AddDescription from 'shared/ui/components/form-components/registrations/AddDescription.vue';
import AddSessionRegistration from 'shared/ui/components/form-components/registrations/AddSessionRegistration.vue';
import Badge from 'shared/ui/components/Badge.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import DatetimeConfigModal from 'shared/ui/components/form-components/registrations/DatetimeConfigModal.vue';
import Draggable from 'vuedraggable';
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import EditorialContent from 'shared/ui/components/form-components/registrations/EditorialContent.vue';
import LegalDropdown from 'shared/ui/components/form-components/registrations/LegalDropdown.vue';
import SessionRegistrationModal from 'shared/ui/components/form-components/registrations/SessionRegistrationModal.vue';

const __vue_script__ = {
    name: 'DynamicFields',

    components: {
        AddDescription,
        Badge,
        Checkbox,
        Draggable,
        DropdownMenu,
        LegalDropdown,
        AddSessionRegistration
    },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            default: () => ({})
        },

        legalDocs: {
            type: Array,
            default: () => []
        },

        value: {
            type: Array,
            default: () => []
        },

        dropdownAnchor: {
            type: String,
            default: 'nw'
        },

        fields: {
            type: Array,
            default: () => []
        },

        exclusions: {
            type: Array,
            default: () => []
        },

        includeRequired: {
            type: Boolean,
            default: false
        },

        manualApproval: {
            type: Boolean,
            default: false,
        },

        capacityEnabled: {
            type: Boolean,
            default: false,
        },

        showEditing: {
            type: Boolean,
            default: false
        },

        lang: {
            type: String,
            default: 'en'
        },

        isSessionRegEnabled: {
            type: Boolean,
            default: false
        },

        selfRegisteredWaitingList: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            eventId: this.event._id,
            showDropdown: false
        };
    },

    computed: {
        /** @returns {object[]} */
        availableFields() {
            const fields = differenceBy(this.fields, this.selectedFields, 'name');
            return fields.filter(f => !this.exclusions.includes(f.name));
        },

        selectedFields: {
            /** @returns {object[]} */
            get() {
                let fields = [];
                if (this.value?.length) {
                    fields = this.value;
                }

                this.sanitizeFields(fields);

                return fields;
            },

            /** @param {object[]} value */
            set(value) {
                this.$emit('input', value);
            }
        },

        /** @returns {object[]} */
        exclude() {
            return [...this.selectedFields, ...this.exclusions.map(e => ({ id: e }))];
        },

        /**
         * shows/hides the button to add session registrations to the form
         * @returns {boolean}
         */
        showSessionRegistration() {
            return this.isSessionRegEnabled && !this.includeRequired && !this.selfRegisteredWaitingList;
        },

        disableSessionRegistration() {
            return this.manualApproval || this.capacityEnabled;
        }
    },

    watch: {
        exclusions: {
            deep: true,
            handler(newValue, oldValue) {
                if (this.value?.length && difference(newValue, oldValue).length !== 0) {
                    const exclusions = newValue.map(e => ({ id: e, name: e }));
                    if (exclusions.length) {
                        const legitFields = differenceBy(this.value, exclusions, 'id');
                        this.selectedFields = differenceBy(legitFields, exclusions, 'name');
                    }
                }
            }
        }
    },

    created() {
        if (this.includeRequired) {
            const required = this.fields
                .filter(f => !this.exclusions.includes(f.name))
                .filter(f => f.required && f.removable === false)
                .map(f => clone(f));

            const diff = differenceBy(required, this.selectedFields, 'name');
            if (diff.length !== 0) {
                this.selectedFields = [...this.selectedFields, ...diff];
            }
        }
    },

    methods: {
        /**
         * Sanitizes the given fields
         *
         * @param {object[]} fields the fields to sanitize
         *
         */
        sanitizeFields(fields) {
            fields.forEach(field => {
                let label;
                if (field.type === 'legal-document') {
                    const doc = this.legalDocs.find(ld => ld._id === field.id) || { title: this.$i18n.t('base.unknown').toString() };
                    label = field.label || doc.title;
                }

                if (field.type === 'text') {
                    label = this.$utils.strings.stripHTML(field.text);
                }

                if (field.type === 'sessions') {
                    label = this.$utils.strings.stripHTML(field.content[this.lang]) || field.name || this.$t('dynamic_fields.sessions_registration');
                }

                if (label) {
                    this.$set(field, 'label', label);
                }
            });
        },

        /**
         * Adds a new field to the set
         *
         * @param {DynamicField} field
         */
        addField(field) {
            field.label = this.getFieldName(field);

            if (field.name === 'country') {
                field.values = this.$utils.collections.getCountryListForSelect();
            }

            if (!field.kind && !field.type) {
                field.kind = 'text';
            }

            this.selectedFields = [...this.selectedFields, field];

            if (field.kind === 'formatted-datetime') {
                this.openDatetimeConfigModal(field);
            }
        },

        /**
         * Edits the give field
         *
         * @param {DynamicField} field
         */
        editField(field) {
            if (field.type === 'text') {
                this.openTextEditModal(field);
            } else if (field.type === 'sessions') {
                this.openSessionRegistrationModal(field);
            } else if (field.kind === 'formatted-datetime') {
                this.openDatetimeConfigModal(field);
            }
        },

        /**
         * Opens a text edit modal for the specified field.
         *
         * @param {Object} field - The field object to be edited.
         */
        openTextEditModal(field) {
            this.openEditingModal(EditorialContent, {
                eventId: this.event._id,
                value: field.text,
                saveCallback: edited => {
                    this.$set(field, 'label', edited.label);
                    this.$set(field, 'text', edited.text);
                },
                allowEmptyValue: false
            });
        },

        /**
         * Opens the session registration modal for a given field.
         *
         * @param {Object} field - The field object.
         */
        openSessionRegistrationModal(field) {
            this.openEditingModal(SessionRegistrationModal, {
                eventId: this.event._id,
                value: field,
                lang: this.lang,
                name: field.name,
                editing: true,
                saveCallback: edited => {
                    this.$set(field, 'label', edited.label);
                    this.$set(field, 'fp_ext_ids', edited.fp_ext_ids);
                    this.$set(field, 'content', edited.content);
                }
            });
        },

        /**
         * Opens the datetime configuration modal for a specific field.
         *
         * @param {Object} field - The field object to configure.
         */
        openDatetimeConfigModal(field) {
            this.openEditingModal(DatetimeConfigModal, {
                value: field,
                name: field.name,
                saveCallback: edited => {
                    if (typeof edited === 'boolean' && !edited) {
                        console.warn('[DynamicFields] The field config deemed invalid. Removing the field.', field);
                        this.removeField(field);
                    } else {
                        this.$set(field, 'kind_options', edited);
                    }
                }
            });
        },

        /**
         * Opens the editing modal with the specified modal component and props.
         *
         * @param {string} modal - The name of the modal component to open.
         * @param {object} props - The props to pass to the modal component.
         */
        openEditingModal(modal, props) {
            this.$modal.show(modal, props, {
                classes: 'small',
                height: 'auto',
                reset: true,
                clickToClose: false
            });
        },

        /**
         * Removes a field from the set
         *
         * @param {DynamicField} field the name of the field to remove
         */
        removeField(field) {
            const removeKey = this.getFieldIdentifier(field);

            this.selectedFields = this.selectedFields.filter(item => this.getFieldIdentifier(item) !== removeKey);
        },

        /**
         * Given an item this method tries to compile the name of the field
         *
         * @param {DynamicField} item
         *
         * @returns {String} the name of the field
         */
        getFieldName(item) {
            if (item.label) {
                return item.label;
            }

            const tKey = `general.forms.labels.${item.name}`;
            return this.$i18n.te(tKey) ? this.$i18n.t(tKey).toString() : this.$utils.strings.humanize(item.name, true);
        },

        /**
         * Finds the correct field unique identifier
         *
         * @param {DynamicField} item
         */
        getFieldIdentifier(item) {
            return item.id || item.name || item.label;
        },

        /**
         * Creates an unique key for each passed field
         *
         * @param {DynamicField} item
         * @param {string} [extraKey]
         */
        getFieldKey(item, extraKey) {
            const key = this.$utils.strings.dasherize(this.getFieldIdentifier(item));
            return uniqueId(`${extraKey}${key}`);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{staticClass:"dynamic-fields",attrs:{"label":_vm.label,"tip":_vm.tip,"name":_vm.name,"hint":_vm.hint,"errors":_vm.errors,"uid":_vm.uid,"warning":_vm.warning,"dependant":_vm.dependant}},[_c('header',[_vm._t("top-header",null,{"selectedFields":_vm.selectedFields}),(_vm.selectedFields.length)?_c('div',{staticClass:"headers"},[_c('div',{staticClass:"drag-handler"}),_c('div',{staticClass:"field-name"},[_vm._v(_vm._s(_vm.$t('dynamic_fields.fields_title')))]),_c('div',{staticClass:"optionality"},[_vm._v(_vm._s(_vm.$t('dynamic_fields.required_title')))]),(_vm.showEditing)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('dynamic_fields.editable_tip')),expression:"$t('dynamic_fields.editable_tip')"}],staticClass:"editability"},[_vm._v(_vm._s(_vm.$t('dynamic_fields.editable_title'))),_c('i',{staticClass:"ic-info-fill"})]):_vm._e(),_c('div',{staticClass:"actions"})]):_vm._e()],2),_c('draggable',{staticClass:"field-list",model:{value:(_vm.selectedFields),callback:function ($$v) {_vm.selectedFields=$$v},expression:"selectedFields"}},_vm._l((_vm.selectedFields),function(item){return _c('div',{key:_vm.getFieldKey(item, 'root-'),staticClass:"field-item",class:[[("type-" + (item.type))]]},[_c('div',{staticClass:"drag-handler"},[_c('i',{staticClass:"icon-reorder"})]),_c('div',{staticClass:"field-name"},[(item.type === 'sessions')?_c('badge',[_vm._v(_vm._s(_vm.$tc('dynamic_fields.number_of_sessions', item.fp_ext_ids.length, [item.fp_ext_ids.length])))]):_vm._e(),(item.kind === 'hidden')?_c('badge',{staticClass:"info"},[_c('i',{staticClass:"ic-eye-off"}),_vm._v(_vm._s(_vm.$t('general.forms.kinds.hidden')))]):_vm._e(),_vm._v(_vm._s(_vm.getFieldName(item)))],1),_c('div',{staticClass:"optionality"},[(item.type !== 'text')?_c('checkbox',{attrs:{"disabled":item.required && item.removable === false,"name":"required"},model:{value:(item.required),callback:function ($$v) {_vm.$set(item, "required", $$v)},expression:"item.required"}}):_vm._e()],1),(_vm.showEditing)?_c('div',{staticClass:"editability"},[(!['text', 'sessions'].includes(item.type))?_c('checkbox',{attrs:{"name":"not_updatable","disabled":item.not_editable,"inverted":true},model:{value:(item.not_updatable),callback:function ($$v) {_vm.$set(item, "not_updatable", $$v)},expression:"item.not_updatable"}}):_vm._e()],1):_vm._e(),_c('div',{staticClass:"actions"},[(['text', 'sessions'].includes(item.type))?_c('a',{staticClass:"edit single btn btn-icon",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.editField(item)}}},[_c('i',{staticClass:"ic-edit"})]):_vm._e(),(['formatted-datetime'].includes(item.kind))?_c('a',{staticClass:"edit single btn btn-icon",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.editField(item)}}},[_c('i',{staticClass:"ic-edit"})]):_vm._e(),(item.removable)?_c('a',{staticClass:"remove single btn btn-icon btn-danger",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.removeField(item)}}},[_c('i',{staticClass:"ic-trash-2"})]):_vm._e()])])}),0),_c('footer',[_c('dropdown-menu',{attrs:{"anchor-pos":_vm.dropdownAnchor,"hide-delay-after-click":0}},[_c('button',{staticClass:"btn btn-ctx-icon",attrs:{"slot":"toggler","disabled":!_vm.availableFields.length},on:{"click":function($event){$event.preventDefault();}},slot:"toggler"},[_vm._v(_vm._s(_vm.$t('dynamic_fields.add_field'))),_c('i',{staticClass:"ic-plus"})]),_c('ul',_vm._l((_vm.availableFields),function(field){return _c('li',{key:_vm.getFieldKey(field, 'menu-')},[_c('a',{staticClass:"available-field",on:{"click":function($event){return _vm.addField(field)}}},[_vm._v(_vm._s(_vm.getFieldName(field)))])])}),0)]),_c('add-description',{attrs:{"event-id":_vm.eventId},on:{"add":_vm.addField}}),_c('legal-dropdown',{attrs:{"legal-docs":_vm.legalDocs,"exclude":_vm.exclude},on:{"add":_vm.addField}}),(_vm.showSessionRegistration)?[_c('add-session-registration',{attrs:{"event-id":_vm.eventId,"lang":_vm.lang,"disabled":_vm.disableSessionRegistration},on:{"add":_vm.addField}}),(_vm.disableSessionRegistration && _vm.manualApproval)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('dynamic_fields.add_session_registration_manual_approval_enabled')),expression:"$t('dynamic_fields.add_session_registration_manual_approval_enabled')"}],staticClass:"ic-info-fill"}):_vm._e(),(_vm.disableSessionRegistration && _vm.capacityEnabled)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('dynamic_fields.add_session_registration_capacity_enabled')),expression:"$t('dynamic_fields.add_session_registration_capacity_enabled')"}],staticClass:"ic-info-fill"}):_vm._e()]:_vm._e(),_vm._t("footer-actions",null,{"selectedFields":_vm.selectedFields,"addField":_vm.addField})],2)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DynamicFields.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__